       
<template>
  <v-alert outlined color="purple">
    <div class="text-h6">Базовый срок</div>
    <div>{{ value }}</div>
  </v-alert>
</template>
<script>
export default {
  name: "base-time",
  props: {
    value: String
  }
};
</script>